(function($, _window, _body) {
	_window.on('elementor/frontend/init', function() {
		elementorFrontend.hooks.addAction('frontend/element_ready/theme-video-archive.default', function($scope, $s) {
			var wrapper = $('.video-archive-wrap', $scope);
			var itemsWrap = $('.item-grid', wrapper);
			var setting = JSON.parse($('.theme-widget-element', $scope)
				.attr('data-setting'));
			var appliedFilter = $.extend({}, {
				page: 1,
				per_page: setting.per_page,
			}, setting.activeFilter);
			var currentPage = 1;
			var maxPages = 1;
			var done = true;
			var tpl = _.template($('#theme-video-archive-tpl')
				.html());
			var applyFilters = function() {
				fetchItems();
			};
			var loader = $('<div>')
				.addClass('theme-ajax-loader')
				.append($('<div>')
					.addClass('inner'));
			var grid = itemsWrap.masonry();
			var fetchItems = function() {
				if (done) {
					done = false;
					var _url = setting.rest;
					wrapper.append(loader);
					$.getJSON(_url, appliedFilter, function(data) {
						var html = $(tpl(data));
						currentPage = data.pagination.currentPage;
						maxPages = data.pagination.maxPages;
						grid.append(html);
						itemsWrap.imagesLoaded(function() {
							grid.masonry('appended', html)
								.masonry('layout');
						});
						done = true;
						loader.remove();
					});
				}
			};
			_window.on('scroll resize load', function() {
				var _offset = $scope.offset()
					.top;
				var rect = $scope[0].getBoundingClientRect();
				if (rect.bottom < (window.innerHeight || document.documentElement.clientHeight) - 100 && done && currentPage < maxPages) {
					appliedFilter.page++;
					applyFilters();
				}
			});
			appliedFilter.page = 1;
			applyFilters();
		});
	});
})(jQuery, jQuery(window), jQuery('body'));